import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      sessionStorage.clear();
      return Object.assign({}, state, {
        isAuthenticated: false,
        user: null,
      });
    },

    setTokens: (_, action) => {
      const { access_token, refresh_token } = action.payload;
      sessionStorage.setItem("access_token", access_token);
      sessionStorage.setItem("refresh_token", refresh_token);
    },
    removeTokens: () => {
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("refresh_token");
    },
    setUserData: (state, action) => {
      state = {
        isAuthenticated: true,
        user: action.payload,
      };
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserData, logout, setTokens, removeTokens } =
  authSlice.actions;

export default authSlice.reducer;
